import Vue from "vue";

Vue.component("WorkshopGenerate", () => import("./Generate.vue"));
Vue.component("WorkshopTimeline", () => import("./Timeline.vue"));
Vue.component("WorkshopMoveForms", () => import("./MoveForms.vue"));
Vue.component("TransferWorkshop", () => import("./Transfer.vue"));
Vue.component("WorkshopShow", () => import("./Show.vue"));

Vue.component("Payments", () => import("./Payments.vue"));
